import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SupplierScoreMeterRiskStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: auto;
  display: flex;
  align-items: center;
  flex-direction: column;

  /* Child element styles
  ------------------------------- */
  .image-control {
    width: 49px;
    height: 33px;

    .image {
      vertical-align: top;
    }
  }

  .score-name {
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
  }

  /* Modifiers
  ------------------------------- */
  &.is-disabled {
    .score-name {
      color: ${VARIABLES.COLORS.GRAY_5};
    }
  }

  /* Media queries
  ------------------------------- */
`
